var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('detail',{attrs:{"data":_vm.data,"onManager":_vm.onManager,"base-info":_vm.baseInfo,"status-module":"clouduser","is-edit-name":false}})}
var staticRenderFns = []

export { render, staticRenderFns }